module.exports = "<p>logout works!</p>\n"